import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { DataService } from 'src/app/Service/data.service';
import { LoadingComponent } from '../../objects/loading/loading.component';

@Component({
  selector: 'app-add-ubicacion',
  templateUrl: './add-ubicacion.component.html',
  styleUrls: ['./add-ubicacion.component.css']
})
export class AddUbicacionComponent implements OnInit {

  @ViewChild('frmnewubicacion', null) frmnewubicacion: ElementRef;
    @ViewChild('btnclose', null) btnclose: ElementRef;
    @ViewChild('loading', null) loading: LoadingComponent;
    public funcion: Function;
    public isShow: boolean = false;
    public isedit: boolean = false;
    public usuario: any;
    public ubicacion: any;
    public options: ALertOption = new ALertOption();
    constructor(private data: DataService) { }
  
    ngOnInit() {
    }
  
  
    public show(affterfunction: Function = null) {
  
      this.funcion = affterfunction;
      this.isShow = true;
      //this.ubicacion = new Ubicacion();
      setTimeout(async () => {
        this.frmnewubicacion.nativeElement.click();
        this.loading.hide();
      }, 10);
    }
  
  
    close() {
      this.btnclose.nativeElement.click();
      setTimeout(() => { this.isShow = false; }, 500);
      setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
    }
  
    GuardarUbicacion(){
      this.data.Post(this.data.api.ubicacion, this.ubicacion).subscribe(
        (res)=>{
          this.data.notify("Datos Guardados exitosamente","Exito",this.data.alertType.success,this.options,() =>{this.close()})
        },
        (err)=>{console.log(err);
        }
      );
    }
  
    EditUbicacion(){
      this.data.Put(this.data.api.ubicacion,this.ubicacion.idubicacion, this.ubicacion).subscribe(
        (res)=>{
          this.data.notify("Datos Actualizados exitosamente","Exito",this.data.alertType.success,this.options,() =>{this.close()})
        },
        (err)=>{console.log(err);
        }
      );
    }
  
    EliminarUbicacion(idubicacion){
      return this.data.Delete(this.data.api.ubicacion,idubicacion)
    }
  
    Save(){
      if(this.ubicacion.idubicacion && this.isedit){
        this.EditUbicacion();
      }else{
        this.GuardarUbicacion();
      }
    }

}
